import SchoolClass from '@/shared/models/entities/school-class';
import AccountUser from '@/shared/models/entities/account-user';
import Grade from '@/shared/models/enums/grade'
import { isNud } from '@/shared/utilities/typing'

/**
 * 注文明細 エンティティ
 */
class OrderDetail {
    order_detail_id;
    grade;
    grade_name;
    school_class;
    account_number;
    exist_account_number;
    issued_account_number;
    account_users;

    constructor(properties) {
        if (isNud(properties)) {
            properties = {};
        }

        this.order_detail_id = properties.order_detail_id;
        this.grade = properties.grade;
        this.grade_name = Grade.getGradeValue(properties.grade);
        this.school_class = new SchoolClass(properties.school_class);
        this.account_number = properties.account_number;
        this.exist_account_number = properties.exist_account_number;
        this.issued_account_number = properties.issued_account_number;
        this.account_users = [];
        if ('account_users' in properties) {
            for (let user of properties.account_users) {
                this.account_users.push(new AccountUser(user));
            }
        }
    }
}

export default OrderDetail;
